import { eventHasRun } from '../../utils/eventTracker';
import findVehicleByProperty from '../../utils/findVehicleByProperty';

export const DDC_LINK_COMPAREPAGECLICK = 'ddc.link.comparePageClick';

function compare(
	{
		DDC: {
			dataLayer: { vehicles }
		}
	},
	{ currentTarget: element, timeStamp }
) {
	let eventObject;
	const $element = $(element);

	if (
		!eventHasRun(DDC_LINK_COMPAREPAGECLICK, {
			timeStamp
		})
	) {
		const vin = $element.data('compareId');
		const { bodyStyle, exteriorColor, make, model, trim, modelYear } =
			findVehicleByProperty('vin', vin, vehicles);
		const position = $element.data('index-position');
		const type = $element.data('type');

		eventObject = {
			eventType: DDC_LINK_COMPAREPAGECLICK,
			eventData: {
				bodyStyle,
				element,
				exteriorColor,
				make,
				model,
				position,
				trim,
				type,
				vin,
				year: modelYear
			}
		};
	}

	return eventObject;
}

export default compare;
